/**
 * SuperAdmin User Groups Endpoints
 * SUPERADMIN: User Groups APIs (list, create, update, delete)
 */

export const USERGROUP_ENDPOINTS = {
  create_userGroup: 'user-group/define-segment',
  list: 'user-group/list-segments',
  getfiledsData:'enrollment-setting/get-all-data',
  getuserGroupById: 'enrollment-setting/list-by-user-group',
  viewFields :'enrollment-setting/view',
  update_userGroup: 'user-group/modify-segment',
  saveEnrollmentSettings: 'enrollment-setting/create',
  updateEnrollmentSettings: 'enrollment-setting/update',
  configureModules: 'enrollment-setting-module/configure-modules',
  updateModule: 'enrollment-setting-module/bulk-update-modules',
  configureEarnings: 'earning-user-group-setting/batch-configure-earnings',
  configurePayouts: 'user-group-payout-config/configure',
  fields_list :'enrollment-approval/available-fields',
  config_approval:'enrollment-approval/configure-complete',
  viewApproval:'enrollment-approval/view-configuration',
};
